// Third-party Components
import { ToastContainer } from "react-toastify";  // Notification system
import { useRoutes } from "react-router-dom";     // Router hook for route configuration
import { Fragment } from "react";                  // React fragment for grouping elements
// Styles and assets
import "./App.css";
import 'react-toastify/dist/ReactToastify.min.css';  // Toast notification styles
import alertIcon from "./assets/images/alert-circle.svg";  // Error icon for notifications
// Application Components
import { routes } from "./routes/routes";           // Route configuration
import CedaHeader from "./components/CedaHeader/CedaHeader";  // Navigation header
// Contexts
import { VisualizationProvider } from './contexts/visualization/VisualizationContext';
import { MapProvider } from './contexts/map/MapContext';
import { FilterProvider } from './contexts/filter/FilterContext';
import { ModalProvider } from './contexts/modal/ModalContext';
import { DataProvider } from './contexts/data/DataContext';
import { DownloadProvider } from "./contexts/chart/DownloadContext";
import { ChartProvider } from "./contexts/chart/ChartContext";
import { ResponsiveProvider } from "./contexts/chart/ResponsiveContext";

function App() {
  // Initialize routing based on configuration
  const routing = useRoutes(routes());

  return (
    <ResponsiveProvider>
    <VisualizationProvider>
    <DataProvider>
      <ChartProvider>
      <MapProvider>
        <FilterProvider>
          <ModalProvider>
              <DownloadProvider>
              <Fragment>
                {/* Overlay for modals and popups */}
                <div className="custom-overlay"></div>

                {/* Main Navigation Header */}
                <CedaHeader/>

                {/* Toast Notification Configuration */}
                <ToastContainer
                  position="bottom-right"
                  autoClose={2000}
                  hideProgressBar={true}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  icon={({ type }) => {
                    // Custom icon based on notification type
                    if (type === "error") return <img className="comapre-icon" src={alertIcon} alt="" />;
                    else return "ℹ️";
                }}
                />
                
                {/* Main Application Routes */}
                {routing}
              </Fragment>
              </DownloadProvider>
          </ModalProvider>
        </FilterProvider>
      </MapProvider>
      </ChartProvider>
      </DataProvider>
    </VisualizationProvider>
    </ResponsiveProvider>
  );
}

export default App;
